import { CDA_4_KIND } from './kinds';

export { MedicalDictionaryType } from '@app/api/Dictionaries';
export { CDA_4_KIND };
